import { render, staticRenderFns } from "./EstablishmentsTableItem.vue?vue&type=template&id=3a558f90&scoped=true"
import script from "./EstablishmentsTableItem.vue?vue&type=script&lang=js"
export * from "./EstablishmentsTableItem.vue?vue&type=script&lang=js"
import style0 from "./EstablishmentsTableItem.vue?vue&type=style&index=0&id=3a558f90&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a558f90",
  null
  
)

export default component.exports